/**
 * @file Renders a text value as a paragraph with the standard label spacing.
 */
import React from "react";
import { Typography } from "antd";

import { W0 } from "@components/Constants";

type Props = {
  text: string;
};

/**
 * Renders the given text as a paragraph with the standard label padding.
 */
const Text = ({ text }: Props): JSX.Element => {
  const labelStyle = {
    paddingTop: W0 / 2,
    paddingLeft: W0,
  };

  return (
    <Typography.Paragraph style={labelStyle}>
      {text}
    </Typography.Paragraph>
  );
};

export default Text;
